import React from 'react';
import CookieUploader from '../Components/cookieManagement/cookieUploader'
import Sidebar from "../Components/sideBar/sideBar";
import Header from "../Components/header/Header";
import { Box } from '@mui/material';

function App() {
    return (
        <Box sx={{ display: "flex" }}>
           <Sidebar
        drawerWidth={260}
      />
      <Box
      
       component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#f9f9f9",
          minHeight: "100vh",
          position: "relative",
        }}>
<Header />
              <Box sx={{ p: 6 }}>
<>
<CookieUploader />

</>

              </Box>
            
      </Box>
            
        </Box>
    );
}

export default App;